import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b3d51ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "star-nodata" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.isLight ? _ctx.imgLight : _ctx.imgDark,
      alt: "",
      class: "star-nodata__img"
    }, null, 8, _hoisted_2),
    _createElementVNode("span", {
      class: "star-nodata__text",
      style: _normalizeStyle({ color: _ctx.isLight ? '#999999' : 'rgba(255,255,255,0.35)' })
    }, _toDisplayString(_ctx.desc), 5)
  ]))
}